export default __webpack_public_path__ + "static/media/certik-logo.9e3b7d11.svg";